import script from "./ApeConstructorMyTraits.vue?vue&type=script&setup=true&lang=js"
export * from "./ApeConstructorMyTraits.vue?vue&type=script&setup=true&lang=js"

import "./ApeConstructorMyTraits.vue?vue&type=style&index=0&id=26c90f3d&lang=scss"

const __exports__ = script;

export default __exports__